export var commCode = commCode || {};

(function () {
    commCode.Animal = {
        ListAnimal: "/api/v1/animal/list_animal",
        CreateAnimal: "/api/v1/animal/create_animal",
        UpdateAnimal: "/api/v1/animal/update_animal",
        DeleteAnimal: "/api/v1/animal/delete_animal",
        SingleAnimal:  "/api/v1/animal/single_animal",
        TopUpAnimal:  "/api/v1/animal/top_up_animal",
        ChgStatusAnimal:  "/api/v1/animal/chg_status_animal"
    };

    commCode.Plant = {
        ListPlant: "/api/v1/plant/list_plant",
        CreatePlant: "/api/v1/plant/create_plant",
        UpdatePlant: "/api/v1/plant/update_plant",
        DeletePlant: "/api/v1/plant/delete_plant",
        SinglePlant:  "/api/v1/plant/single_plant",
        TopUpPlant:  "/api/v1/plant/top_up_plant",
        ChgStatusPlant:  "/api/v1/plant/chg_status_plant"
    };

    commCode.Reservation = {
        ListReservation: "/api/v1/reservation/list_reservation",
        CreateReservation: "/api/v1/reservation/create_reservation",
        ChgStatusReservation: "/api/v1/reservation/chg_status_reservation",
        DeleteReservation: "/api/v1/reservation/delete_reservation",
        SingleReservation:  "/api/v1/reservation/single_reservation",
        TopUpReservation:  "/api/v1/reservation/top_up_reservation",
        UpdateReservation: "/api/v1/reservation/update_reservation",
    };



    commCode.SessionLocation = {
        ListSessionLocation: "/api/v1/session_location/list_session_location",
        ListSessionLocationBySessionCode: "/api/v1/session_location/list_session_location_by_session_code",
        CreateSessionLocation: "/api/v1/session_location/create_session_location",
        UpdateSessionLocation: "/api/v1/session_location/update_session_location",
        DeleteSessionLocation: "/api/v1/session_location/delete_session_location",
        SingleSessionLocation:  "/api/v1/session_location/single_session_location",
        TopUpSessionLocation:  "/api/v1/session_location/top_up_session_location",
        ChgStatusSessionLocation:  "/api/v1/session_location/chg_status_session_location"
    };

    commCode.SessionInfo = {
        ListSessionInfo: "/api/v1/session-info/list_session_info",
        DistinctSessionInfo: "/api/v1/session-info/distinct_session_info",
        CreateSessionInfo: "/api/v1/session-info/create_session_info",
        UpdateSessionInfo: "/api/v1/session-info/update_session_info",
        DeleteSessionInfo: "/api/v1/session-info/delete_session_info",
        SingleSessionInfo:  "/api/v1/session-info/single_session_info",
        TopUpSessionInfo:  "/api/v1/session-info/top_up_session_info",
        ChgStatusSessionInfo:  "/api/v1/session-info/chg_status_session_info",
        ListCancelSessionInfo : "/api/v1/session-info/list_cancel_session_info",
        CancelReserved:'/api/v1/session-info/cancel_reserved'
    };


    commCode.ReservedPerson = {
        ListReservedPersonURL: "/api/v1/reserved-person/list_reserved_person",
        CreateReservedPerson: "/api/v1/reserved-person/create_reserved_person",
        UpdateReservedPerson: "/api/v1/reserved-person/update_reserved_person",
        DeleteReservedPerson: "/api/v1/reserved-person/delete_reserved_person",
        SingleReservedPerson:  "/api/v1/reserved-person/single_reserved_person",
        TopUpReservedPerson:  "/api/v1/reserved-person/top_up_reserved_person",
        ApproveReservedPerson:  "/api/v1/reserved-person/approve_reserved_person",
        VerificationReservedPerson:  "/api/v1/reserved-person/verification_reserved_person",
        DetailReservedList:  "/api/v1/reserved-person/detail_reserved_list"
    };

    commCode.ReservedTeam = {
        ListReservedTeam: "/api/v1/reserved-team/list_reserved_team",
        CreateReservedTeam: "/api/v1/reserved-team/create_reserved_team",
        UpdateReservedTeam: "/api/v1/reserved-team/update_reserved_team",
        DeleteReservedTeam: "/api/v1/reserved-team/delete_reserved_team",
        SingleReservedTeam:  "/api/v1/reserved-team/single_reserved_team",
        ApprovalReservedTeam:  "/api/v1/reserved-team/approval_reserved_team",

    };


    commCode.Customer = {
        ListCustomer: "/api/v1/customer/list_customer",
        CreateCustomer: "/api/v1/customer/create_customer",
        UpdateCustomer: "/api/v1/customer/update_customer",
        DeleteCustomer: "/api/v1/customer/delete_customer",
        SingleCustomer:  "/api/v1/customer/single_customer",
        TopUpCustomer:  "/api/v1/customer/top_up_customer",
        ChgStatusCustomer:  "/api/v1/customer/chg_status_customer"
    };


    commCode.Visitor = {
        ListVisitor: "/api/v1/visitor/list_visitor",
        CreateVisitor: "/api/v1/visitor/create_visitor",
        UpdateVisitor: "/api/v1/visitor/update_visitor",
        DeleteVisitor: "/api/v1/visitor/delete_visitor",
        SingleVisitor:  "/api/v1/visitor/single_visitor",
        TopUpVisitor:  "/api/v1/visitor/top_up_visitor",
        ChgStatusVisitor:  "/api/v1/visitor/chg_status_visitor"
    };


    commCode.House = {
        ListHouse: "/api/v1/house/list_house",
        CreateHouse: "/api/v1/house/create_house",
        UpdateHouse: "/api/v1/house/update_house",
        DeleteHouse: "/api/v1/house/delete_house",
        SingleHouse:  "/api/v1/house/single_house",
        TopUpHouse:  "/api/v1/house/top_up_house",
        ChgStatusHouse:  "/api/v1/house/chg_status_house"
    };


    commCode.Insect = {
        ListInsect: "/api/v1/insect/list_insect",
        CreateInsect: "/api/v1/insect/create_insect",
        UpdateInsect: "/api/v1/insect/update_insect",
        DeleteInsect: "/api/v1/insect/delete_insect",
        SingleInsect:  "/api/v1/insect/single_insect",
        TopUpInsect:  "/api/v1/insect/top_up_insect",
        ChgStatusInsect:  "/api/v1/insect/chg_status_insect"
    };

    commCode.LargeFungi = {
        ListLargeFungi: "/api/v1/large-fungi/listLargeFungi",
        CreateLargeFungi: "/api/v1/large-fungi/createLargeFungi",
        UpdateLargeFungi: "/api/v1/large-fungi/updateLargeFungi",
        DeleteLargeFungi: "/api/v1/large-fungi/deleteLargeFungi",
        SingleLargeFungi:  "/api/v1/large-fungi/singleLargeFungi",
        TopUpLargeFungi:  "/api/v1/large-fungi/top_upLargeFungi",
        ChgStatusLargeFungi:  "/api/v1/large-fungi/chg_statusLargeFungi"
    };

    commCode.NaturalLandscape = {
        ListNaturalLandscape: "/api/v1/natural-landscape/listNaturalLandscape",
        CreateNaturalLandscape: "/api/v1/natural-landscape/createNaturalLandscape",
        UpdateNaturalLandscape: "/api/v1/natural-landscape/updateNaturalLandscape",
        DeleteNaturalLandscape: "/api/v1/natural-landscape/deleteNaturalLandscape",
        SingleNaturalLandscape:  "/api/v1/natural-landscape/singleNaturalLandscape",
        TopUpNaturalLandscape:  "/api/v1/natural-landscape/top_upNaturalLandscape",
        ChgStatusNaturalLandscape:  "/api/v1/natural-landscape/chg_statusNaturalLandscape"
    };



    commCode.WechatArticle = {
        CreateWechatArticle: "/api/v1/wechat_article/create_wechat_article",
        ListWechatArticle: "/api/v1/wechat_article/list_wechat_article",
        DeleteWechatArticle: "/api/v1/wechat_article/delete_wechat_article",
        SingleWechatArticle: "/api/v1/wechat_article/single_wechat_article",
        SyncOfficialAccountArticles: "/api/v1/wechat_article/sync_official_account_articles",
        ListWechatMenuSyncOptions: "/api/v1/wechat_article/list_wechat_menu_sync_options",
        SyncWechatMenuURLArticles: "/api/v1/wechat_article/sync_wechat_menu_url_articles",

    };


    commCode.Survey = {
        CreateQuestion: "/api/v1/survey/create_question",
        ListQuestion: "/api/v1/survey/list_question",
        CreateSurvey: "/api/v1/survey/create_survey",
        GetSurvey: "/api/v1/survey/get_survey",
        SubmitAnswer: "/api/v1/survey/submit_answer",
        GetSurveyAnswers:  "/api/v1/survey/get_survey_answers",
        PublishSurvey:  "/api/v1/survey/publish_survey",
        CloseSurvey:  "/api/v1/survey/close_survey",
        ListSurveys:  "/api/v1/survey/list_surveys",
        ChangeSurveyStatus:  "/api/v1/survey/change_survey_status",
        GetQuestionAnswersStat:  "/api/v1/survey/get_question_answers_stat"
    };



    commCode.Home = {
        GetDefaultMainData: "/api/v1/home/GetDefaultMainData",

    };


})();
